import React from 'react';


/**
 * BallButton component
 * @class
 */
const BallButton = React.createClass({
  displayName: 'BallButton',


  propTypes: {
    clickHandler: React.PropTypes.func,
    touchStartHandler: React.PropTypes.func,
    touchEndHandler: React.PropTypes.func,
    refreshIcon: React.PropTypes.bool,
    touch: React.PropTypes.bool,
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  render() {
    const mouseDownHandler = !this.props.touch ? this.props.touchStartHandler : null;
    const touchStartHandler = this.props.touch ? this.props.touchStartHandler : null;
    const touchEndHandler = this.props.touch ? this.props.touchEndHandler : null;
    const mouseUpHandler = !this.props.touch ? this.props.touchEndHandler : null;
    const iconClass = this.props.refreshIcon ? ' refresh' : ' plus';
    const className = 'component-ball-button' + iconClass;

    return (
      React.createElement("div", {
        className: className, 
        onMouseDown: mouseDownHandler, 
        onTouchStart: touchStartHandler, 
        onMouseUp: mouseUpHandler, 
        onTouchEnd: touchEndHandler
      }, 
        React.createElement("div", {
          className: "ball", 
          dangerouslySetInnerHTML: { __html: this._renderButtonSvg()}}
        ), 
        React.createElement("div", {
          className: "icon", 
          dangerouslySetInnerHTML: { __html: this._renderIconSvg()}}
        )
      )
    );
  },


  /**
   * Renders ball svg
   * @returns {ReactElement} A React element
   */
  _renderButtonSvg() {
    return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 889 889" style="enable-background:new 0 0 889 889;" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;}.st1{fill:#FF585F;}</style><circle class="st0" cx="444.5" cy="444.5" r="443.6"/><g><path class="st1" d="M854.1,271.5c-22.4-52.9-54.4-100.5-95.3-141.3C718,89.3,670.5,57.3,617.5,34.9C562.7,11.7,504.5,0,444.5,0 s-118.2,11.7-173,34.9C218.6,57.3,171,89.3,130.2,130.2C89.3,171,57.3,218.5,34.9,271.5C11.7,326.3,0,384.5,0,444.5 s11.8,118.2,34.9,173c22.4,52.9,54.4,100.5,95.3,141.3c40.8,40.8,88.4,72.9,141.3,95.3c54.8,23.2,113,34.9,173,34.9 s118.2-11.8,173-34.9c52.9-22.4,100.5-54.4,141.3-95.3s72.9-88.3,95.3-141.3c23.2-54.8,34.9-113,34.9-173S877.3,326.3,854.1,271.5z M35.9,444.5c0-55.2,10.8-108.7,32.1-159c17.6-41.7,41.8-79.7,72-113.4c67.2,75,104.1,171,104.1,272.4c0,55.2-10.8,108.7-32.1,159 c-17.6,41.7-41.8,79.7-72,113.4c-30.2-33.6-54.3-71.7-72-113.4C46.7,553.2,35.9,499.7,35.9,444.5z M603.5,821 c-44.9,19-92.2,29.6-141,31.7V607.5h-36v245.2c-48.8-2.1-96.2-12.7-141-31.7c-44.6-18.8-84.9-45.2-120.2-78.3 c33.6-37,60.4-79,79.9-125.1c23.2-54.8,34.9-113,34.9-173c0-111.1-40.6-216.3-114.8-298.2C200.6,113.3,241,87,285.5,68.1 c44.9-19,92.2-29.6,141-31.7v245.1h36V36.3c48.8,2.1,96.2,12.7,141,31.7c44.6,18.8,84.9,45.2,120.2,78.3 c-33.6,37-60.4,79-79.9,125.1c-23.2,54.8-34.9,113-34.9,173c0,111.1,40.6,216.3,114.8,298.2C688.5,775.8,648.1,802.1,603.5,821z M821,603.5c-17.6,41.7-41.8,79.7-72,113.4c-67.2-75-104.1-171-104.1-272.4c0-55.2,10.8-108.7,32.1-159 c17.6-41.7,41.8-79.7,72-113.4c30.2,33.6,54.3,71.7,72,113.4c21.3,50.4,32.1,103.9,32.1,159C853.1,499.7,842.3,553.2,821,603.5z"/></g></svg>';
  },


  /**
   * Renders icon svg
   * @returns {ReactElement} A React element
   */
  _renderIconSvg() {
    let iconSvg;

    if (!this.props.refreshIcon) {
      iconSvg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 264 264" style="enable-background:new 0 0 264 264;" xml:space="preserve"><polygon points="150,0 114,0 114,114 0,114 0,150 114,150 114,264 150,264 150,150 264,150 264,114 150,114 "/></svg>';
    } else {
      iconSvg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 242.4 239" style="enable-background:new 0 0 242.4 239;" xml:space="preserve"><g><path d="M195.4,185.7c-18.5,20.9-45.5,34.1-75.6,34.1C64.1,219.8,19,174.7,19,119S64.1,18.2,119.8,18.2 c34.6,0,65.2,17.5,83.4,44.1"/><polyline points="151.9,99.5 242.4,99.5 242.4,9"/></g></svg>';
    }

    return iconSvg;
  },
});

export default BallButton;
